/** Post-login / fallback home route (intentional fixed path). */
export const HOME_PATH = '/dashboard';
